import { render, staticRenderFns } from "./EditFoodRecipes.vue?vue&type=template&id=0fabd715&"
import script from "./EditFoodRecipes.vue?vue&type=script&lang=js&"
export * from "./EditFoodRecipes.vue?vue&type=script&lang=js&"
import style0 from "./EditFoodRecipes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports